
export function print_price(language, price) {
  if (language === "Dutch")
    return print_price_dutch(price);
  return print_price_german(price);
}

function print_price_german(price) {
  if (Math.floor(price) === price)
    return `${price} €`
  const cents = (Math.floor(price / 0.01)) % 100;
  return `${Math.floor(price)},${cents} €`
}

function print_price_dutch(price) {
  if (Math.floor(price) === price)
    return `€${price},-`
  const cents = (Math.floor(price / 0.01)) % 100;
  return `€${Math.floor(price)},${cents}`
}

export class PriceCalculation {
  constructor(adults, children, toddlers, rooms, nights, christmas_nights) {
    this.adults = adults;
    this.children = children;
    this.toddlers = toddlers;
    this.rooms = rooms;
    this.nights = nights;
    this.christmas_nights = christmas_nights ?? 0;

    this.adult_fee = 51;
    this.child_fee = 34;
    this.single_fee = 21;
    this.one_night_fee = 10;
    this.christmas_fee = 10;
    this.nightly_tourist_tax = 3;

    this.single_rooms =
      Math.min(rooms, Math.max(0, 2*rooms - adults - children));
    this.cost_per_night =
      (adults*this.adult_fee
      + children*this.child_fee
      + this.single_rooms*this.single_fee
      + this.nightly_tourist_tax * (adults + children + toddlers));
    this.cost_per_christmas_night =
      this.cost_per_night + adults*this.christmas_fee;

    if (Number.isFinite(this.nights)) {
      this.one_night_surcharge =
        (this.nights === 1 ? adults * this.one_night_fee : 0);
      this.christmas_surcharge =
        this.christmas_nights * adults * this.christmas_fee;
      this.total_cost = nights * this.cost_per_night
        + this.christmas_surcharge + this.one_night_surcharge;
    }

    this.too_few_rooms = (adults > 2*rooms);
    this.too_few_adults = (rooms > adults);
    this.has_error = this.too_few_adults || this.too_few_rooms;
  }
}